import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register required components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

ChartJS.defaults.plugins.datalabels = {
  display: false,
};

const fmtAmount = (n) => {
  const num = Number(n);
  // Always format to 2 decimal places for proper alignment
  const formatted = num.toFixed(2);
  // Split into integer and decimal parts for comma formatting
  const parts = formatted.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];
  // Add commas to integer part
  const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${integerWithCommas}.${decimalPart}`;
};

const GlamBudgetChart = () => {
  const labels = [
    "Federal Funds",
    "Income Tax Fund",
    "Other Funds",
    "General Fund",
    "Dedicated Credit",
    "Transportation Investment Fund",
    "Local Education Revenue",
    "Transportation Fund",
  ];

  const values = [8.3, 6.6, 4.9, 3.7, 2.3, 2.2, 1.8, 0.9];

  const colors = [
    "#6E11B090",
    "#E69BC690",
    "#8064A290",
    "#4683B190",
    "#E6B1B190",
    "#EDE3B790",
    "#6ED5BE90",
    "#DCE28B90",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Amount ($ Billion)",
        data: values,
        backgroundColor: colors,
        borderRadius: 8,
        barThickness: 28,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        display: true,
        color: "#000",
        anchor: "end",
        align: "left",
        formatter: (value) => value.toFixed(2),
        font: { weight: "bold", size: 13 },
      },
      tooltip: {
        backgroundColor: "#1F2937",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#fff",
        borderWidth: 1,
        callbacks: {
          label: (context) => {
            const val = context.parsed.x || 0;
            return ` Amount (Billion $) - ${val.toFixed(2)}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Amount ($ Billion)",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: { color: "#333" },
        grid: { display: true, color: "#ddd" },
      },
      y: {
        title: {
          display: true,
          text: "Category",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: {
          color: "#111",
          font: { size: 12, weight: "500" },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div className="overflow-x-auto">
      <div className="p-3 bg-white rounded-3 border min-w-[900px] sm:min-w-full">
        <h2 className="text-center text-xl font-bold mb-4">
          Funding Sources of Utah Budget FY 2026
        </h2>

        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default GlamBudgetChart;
